<template>
  <fragment>
    <v-card height="100%" style="padding-bottom: 55px;">
    <!--<v-card height="100%">-->
      <v-img :src="require(`../assets/${storeData.properties.img_path}`)" height="240"
             @click="scrollToMap" style="cursor: pointer;"/>
      <v-card-title>
        {{ storeData.properties.name }}
      </v-card-title>
      <v-card-subtitle v-html="$t(storeData.properties.description2)" />
      <v-card-text>
        <div class="mb-4">
          <div class="font-weight-bold">
            {{ $t('address') }}
          </div>
          <div>
            {{ $t(storeData.properties.address2) }}
          </div>
        </div>
        <div>
          <div class="font-weight-bold">
            {{ $t('openingHours')}}
          </div>
          <div v-html="$t(storeData.properties.hours2)"></div>
        </div>
        <!--div class="mt-4">
          <div class="font-weight-bold">
            {{ $t('xmasOpening') }}:
          </div>
          <div v-html="$t(storeData.properties.xmasHours)"></div>
        </div-->
        <div v-if="storeData.properties.phone" class="mt-4">
          <div class="font-weight-bold">
            {{ $t('phone') }}
          </div>
          <div>
            {{ $t(storeData.properties.phone) }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="storeCard-actions" v-if="storeData.properties.cardButton">
        <v-btn color="primary" text @click="goToStoreSite(storeData.properties.cardButton.url)" class="mx-auto">
          {{ storeData.properties.cardButton.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </fragment>
</template>

<script>
export default {
  name: 'storeCard',
  props: {
    storeData: Object,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    scrollToMap() {
      this.$emit('on-image-click');
    },
    goToStoreSite(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>

</style>
